<template>
  <div class="horiz">
    <router-link to="payment" class="m-l-0-5v navbutton" v-bind:class="{ navselected: selindex === 1 }">How Money Works?</router-link>
    <router-link to="income" class="m-l-0-5v navbutton" v-bind:class="{ navselected: selindex === 0 }">What's your number?</router-link>
    <router-link to="calculator" class="m-l-0-5v navbutton" v-bind:class="{navselected: selindex === 2}">Calculator</router-link>
  </div>
  </template>

<script>
  export default {
    name: 'navbar',
    props: ['selindex'],
  }

</script>

<style scoped>
.navbutton {
  background-color: var(--primary);
  border-radius: 0.5em 0.5em 0 0;
  margin-bottom: 0;
  margin-top: 10px;
  padding-top: 5px;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  text-decoration: none;
  color: var(--comp-dark);
}
.navbutton:hover {
  background-color: #ffffff;
  color: #000000;
  text-decoration: none;
}
.navselected {
  background-color: var(--primary-light);
  margin-top: 10px;
  padding-top: 5px;
  color: var(--comp-dark);
}
.navselected:hover {
  background-color: var(--primary-light);
}
</style>
